import { computed, ref } from 'vue';
import { listTerminals, saveTerminal } from '@/api/settingsApi';
import { useSettingsEntityList } from './useSettingsEntityList';

export function useTerminals() {
  const { afterMutation } = useSettingsEntityList();

  const loading = ref(false);
  const saving = ref(false);
  const error = ref(null);
  const items = ref([]);
  const searchQuery = ref('');

  const filteredItems = computed(() => {
    const q = searchQuery.value.trim().toLowerCase();
    if (!q) return items.value;
    return items.value.filter((row) => {
      const hay = [row.label, row.id].filter(Boolean).join(' ').toLowerCase();
      return hay.includes(q);
    });
  });

  const countLabel = computed(() => {
    const n = filteredItems.value.length;
    const total = items.value.length;
    if (searchQuery.value.trim() && n !== total) {
      return `${n} of ${total} terminals`;
    }
    return `${total} terminal${total === 1 ? '' : 's'}`;
  });

  async function loadItems() {
    loading.value = true;
    error.value = null;
    try {
      const data = await listTerminals({ includeInactive: true });
      items.value = Array.isArray(data?.items) ? data.items : [];
    } catch (e) {
      error.value = e?.message || 'Failed to load terminals';
    } finally {
      loading.value = false;
    }
  }

  async function saveItem(payload) {
    saving.value = true;
    error.value = null;
    try {
      const data = await saveTerminal(payload);
      await afterMutation(async () => {
        if (Array.isArray(data?.items)) {
          items.value = data.items;
        } else {
          await loadItems();
        }
      });
      return data?.item || null;
    } catch (e) {
      error.value = e?.message || 'Failed to save terminal';
      throw e;
    } finally {
      saving.value = false;
    }
  }

  return {
    loading,
    saving,
    error,
    items,
    searchQuery,
    filteredItems,
    countLabel,
    loadItems,
    saveItem
  };
}
